// Placeholder imagery for the landing page. picsum.photos gives stable,
// real-looking photography by seed. Swap for curated assets before a real push.
export const POOL = [
  'joy01', 'fest22', 'wed14', 'trip07', 'party33', 'beach18', 'dinner05', 'kids29',
  'hike41', 'concert12', 'picnic26', 'bday09', 'reunion31', 'street44', 'garden16',
  'sunset02', 'market38', 'cafe23', 'boat47', 'snow15', 'festival08', 'grad19',
  'camp27', 'rooftop36', 'market11', 'lake24', 'market52', 'glow61', 'spark73',
  'warm82', 'event91', 'frame45', 'album56', 'memory63', 'group77', 'candid88',
  'flash94', 'polaroid99', 'shutter66', 'zoom71',
]

export const img = (seed: string, w: number, h: number): string =>
  `https://picsum.photos/seed/${seed}/${w}/${h}`
